import { inject, Injectable } from "@angular/core";
import { BehaviorSubject, map, Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { safeFirstValueFrom } from "../utils/safe-first-value-from";

@Injectable({
  providedIn: "root",
})
export class QrLinkService {
  private http = inject(HttpClient);
  private _linked$ = new BehaviorSubject<boolean>(false);

  constructor() {}

  get linked$(): Observable<boolean> {
    return this._linked$.asObservable();
  }

  setLinked(l: boolean) {
    this._linked$.next(l);
  }

  async getShortLink(payload: {
    hostname: string;
    socketId: string;
    type: string;
    controleId: string;
    lotId: string;
    ofId: string;
    opeId: string;
    forList: boolean;
    token: string;
    ssoToken: string;
  }) {
    return await safeFirstValueFrom(
      this.http
        .post<{
          shortCode: string;
        }>(`${environment.api()}/qrlink/generate`, payload)
        .pipe(
          map((sl) => {
            let baseUrl;
            if (environment.api().includes("http")) {
              baseUrl = environment.api();
            } else {
              baseUrl = `${location.protocol}//${location.host}${environment.api()}`;
            }

            return `${baseUrl}/qrlink/${sl.shortCode}`;
          }),
        ),
    );
  }
}
